import React from 'react';
import { FlowForm, getKeyHandler } from 't-lib-ui/structure';
import HomeIcon from './HomeIcon';
import './HeaderCrumbs.css';

/**
 * Breadcrumb navigation as a PageHeader title: "Home / Parent / Current", the earlier levels
 * clickable. The header sits outside the page's main FlowForm, so the crumbs get their own: arrow-up
 * from the content reaches them, left/right moves between them. The links stop propagation so the
 * narrow-screen header click doesn't also open the sidebar.
 */
export const HeaderCrumbsForm: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <FlowForm className="headerCrumbsForm"><span className="headerCrumbs">{children}</span></FlowForm>
);

/** Returns a function rendering a crumb link (followed by its separator). */
export const makeCrumb = (onNavigate: (path: string) => void) => (path: string, content: React.ReactNode) => (
  <>
    <button
      type="button"
      tabIndex={0}
      className="headerCrumb flowFocussable sidewayFocus"
      onClick={e => { e.stopPropagation(); onNavigate(path); }}
      onKeyDown={getKeyHandler(() => onNavigate(path)) as any}
    >
      {content}
    </button>
    <span className="headerCrumbSep">/</span>
  </>
);

/** Content of a "Home" crumb. */
export const homeCrumb = <span className="headerCrumbHome"><HomeIcon size={16} />Home</span>;

/** The last, current level. */
export const CurrentCrumb: React.FC<{ icon?: React.ReactNode; children: React.ReactNode }> = ({ icon, children }) => (
  <span className="headerCrumbCurrent">
    {icon}
    <span className="headerCrumbLabel">{children}</span>
  </span>
);
